import { ROUTING_NUMBERS_FED_NOW } from "@wingspanhq/users/dist/lib/constants/fedNowList";
import { ROUTING_NUMBERS_RTP } from "@wingspanhq/users/dist/lib/constants/rtpList";

export const isEligibleRoutingNumber = (routingNumber: string) => {
  return (
    ROUTING_NUMBERS_RTP.includes(routingNumber) ||
    ROUTING_NUMBERS_FED_NOW.includes(routingNumber)
  );
};
